import { react, useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import RadioIcon from '@mui/icons-material/Radio';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import FacebookIcon from '@mui/icons-material/Facebook';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import TokenService from '../../services/TokenService'
import EmailIcon from '@mui/icons-material/Email';
import ErrorIcon from '@mui/icons-material/Error';

export default function Confirmation(props) {

    const [selectedLead, setSelectedLead] = useState('');

    function handleUpdateSalesLead(lead) {
        setSelectedLead(lead);
        let postData = {
            requestId: props.pickupRequest.RequestId,
            lead: lead
        }
        TokenService.post(postData, 'UpdateSalesLead', '')
            .then((response) => {
                
            })
            .catch((response) => {
               
            });
    }

    return (
        <div>
            <div style={{ marginTop: '20px', color: 'var(--sipzee-yellow)', fontSize: '22pt', fontWeight: 'bold' }}>THANK YOU FOR THE REQUEST</div>

            <div style={{ display: 'flex', flexDirection:'row', marginTop:'20px' }}>
                <ErrorIcon sx={{ fontSize: '50px', color: 'var(--sipzee-red)', alignSelf:'center' }} />
                <div style={{ color: 'var(--sipzee-red)', fontSize: '18pt', fontWeight: 'bold' }}>
                    Your request is not yet active. Please click the order link that we just emailed{props.pickupRequest.CustomerWantsTextMsg ? '/texted' : ''} you to activate your request.
                </div>
            </div>
          

           
            <div style={{ marginTop: '20px' }} >This helps us ensure that we got your email {props.pickupRequest.CustomerWantsTextMsg ? ' and phone number ' : ''}correct.</div>

            <div style={{ marginTop: '20px', width:'100%', borderBottom:'2px solid var(--sipzee-gray)' }} ></div>

            {props.pickupRequest.RequestSalesLead == false ? null :
                <div>
                    <div style={{ marginTop: '20px', color: 'var(--sipzee-green)', fontSize: '20pt', fontWeight: 'bold' }}>How did you hear about us?</div>
                    <div style={{ display: 'flex', justifyContent:'center' }}>
                        <Button
                            variant='outlined'
                            style={{ marginLeft: '2px', marginRight: '2px', height:'65px', width:'65px', backgroundColor: selectedLead == 'Radio' ? '#c5c5c5' : ''}}
                            onClick={() => handleUpdateSalesLead('Radio')}>
                            <div>
                                <RadioIcon />
                                <div style={{fontSize:'8pt'} }>Radio</div>
                            </div>
                        </Button>
                        <Button variant='outlined' style={{ marginRight: '2px', height: '65px', width: '65px', backgroundColor: selectedLead == 'Social Media' ? '#c5c5c5' : '' }} onClick={() => handleUpdateSalesLead('Social Media')}>
                            <div>
                                <FacebookIcon />
                                <div style={{ fontSize: '8pt' }}>Social</div>
                            </div>
                        </Button>
                        <Button variant='outlined' style={{ marginRight: '2px', height: '65px', width: '65px', backgroundColor: selectedLead == 'Web Search' ? '#c5c5c5' : '' }} onClick={() => handleUpdateSalesLead('Web Search')}>
                            <div>
                                <ScreenSearchDesktopIcon />
                                <div style={{ fontSize: '8pt' }}>WWW</div>
                            </div>
                        </Button>
                        <Button variant='outlined' style={{ marginRight: '2px', height: '65px', width: '65px', backgroundColor: selectedLead == 'Friend' ? '#c5c5c5' : '' }} onClick={() => handleUpdateSalesLead('Friend')}>
                            <div>
                                <PeopleAltIcon />
                                <div style={{ fontSize: '8pt' }}>Friend</div>
                            </div>
                        </Button>
                        <Button variant='outlined' style={{ marginRight: '2px', height: '65px', width: '65px', backgroundColor: selectedLead == 'Other' ? '#c5c5c5' : '' }} onClick={() => handleUpdateSalesLead('Other')}>
                            <div>
                                <AllInclusiveIcon />
                                <div style={{ fontSize: '8pt' }}>Other</div>
                            </div>
                        </Button>
                    </div>
                </div>
            }

            <div style={{ marginTop: '20px', width: '100%', borderBottom: '2px solid var(--sipzee-gray)' }} ></div>

            <div style={{ marginTop: '20px', color: 'var(--sipzee-green)', fontSize: '22pt', fontWeight: 'bold' }}>What's next?</div>
            <div>Once you active your pickup request, it will be added to our Sipzee Marketplace where a recycler will claim it and schedule a pickup date and time window.
                Please place your bottles & cans in garbage bags or boxes.
                Please have your returns available during the scheduled window for a contact-less pickup.
                Our recyclers use their personal vehicles and cannot empty a trash bin of loose bottles & cans into their car.
            </div>

            <div style={{ marginTop: '20px', width: '100%', borderBottom: '2px solid var(--sipzee-gray)' }} ></div>

            <div style={{ marginTop: '20px', color: 'var(--sipzee-green)', fontSize: '22pt', fontWeight: 'bold' }}>What if nobody schedules my pickup?</div>
            <div>
                In order to provide great service, we try to only open up new areas if enough recyclers are servicing it.
                Our recyclers are not employees and get to select when they want to pickup. While it is unusual, your pickup request could remain unclaimed for several days.
            </div>
        </div>
    )
}